
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.5 12.938H.234V5.57c0-1.52.378-2.7 1.133-3.539C2.122 1.193 3.224.773 4.672.773c1.448 0 2.547.43 3.297 1.29.755.854 1.133 2.132 1.133 3.835v7.04H7.836v-7.07c0-1.365-.268-2.373-.805-3.024-.531-.656-1.317-.985-2.36-.985-1.04 0-1.83.329-2.366.985-.537.65-.805 1.659-.805 3.023v7.07z","fill":"currentColor"}})])
          )
        }
      }
    